import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';

export class ChatRenameFormAdapter extends FormAdapter {

	idChat: number = null;
	name: string = null;

	getColumns() {
		return [
			{width: 100},
			{width: null},
		];
	}

	async getControls() {
		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'name', value: this.name, required: true},
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [
				"save",
				"close"
			]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		await rp.ms('ai').patch(`chats/${this.idChat}`, { name: (formValues.name as string).trim() });
		return true;
	}

};
